var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LineChartGenerator',{attrs:{"options":_vm.chartOptions,"data":_vm.data,"styles":_vm.styles}})
}
var staticRenderFns = []

export { render, staticRenderFns }